<div class="row">
  <div class="col-sm-8 col-sm-offset-2">
    <h2>Sign In</h2>
    <br>
    <form [formGroup]="signInForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="email">Email</label>
        <input type="text" id="email" class="form-control" formControlName="email">
      </div>
      <div class="form-group">
        <label for="password">Password</label>
        <input type="password" id="password" class="form-control" formControlName="password">
      </div>
      <br>
      <button class="btn btn-primary" type="submit" [disabled]="signInForm.invalid">Log In</button>
      <p class="text-danger">{{ errorMessage }}</p>
    </form>
  </div>
</div>